import { UIBrandedFareFeature, UIBrandedFareInfo } from "@flights/types";
import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_show_sellable_and_excluded_seats",
  stages: {
    affected_users: 1,
    main: 2,
    ddot: 3,
    mdot: 4,
    lowest_with_exclusion_upsell_with_inclusion: 5,
    lowest_with_exclusion_upsell_with_sellable: 6,
    lowest_with_basic_sellable: 7,
    lowest_with_seats_excluded: 8,
    check_pay_with_seat_included_but_seatmap_not_available: 9
  },
  goals: {
    open_seatmap: 1,
    seatmap_action_click_with_seat_selected: 2
  },
  defaultStage: 1
});

const trackStages = (isMobile: boolean, brandedFareOffers: { brandedFareInfo: UIBrandedFareInfo }[]) => {
  if (!brandedFareOffers.some((offer) => offer.brandedFareInfo.featuresList?.some(isSeat))) return;

  utils.stages.main();

  if (!isMobile) utils.stages.ddot();
  if (isMobile) utils.stages.mdot();

  if (brandedFareOffers.length <= 1) return;

  const [lowest, upsell] = brandedFareOffers;

  const lowestHasExcludedSeat = lowest.brandedFareInfo.featuresList.some(isExcludedSeat);
  const lowestHasBasicSellableSeat = lowest.brandedFareInfo.featuresList.some(isBasicSellableSeat);
  const upsellHasIncludedSeat = upsell.brandedFareInfo.featuresList.some(isIncludedSeat);
  const upsellHasSellableSeat = upsell.brandedFareInfo.featuresList.some(isSellableSeat);

  if (lowestHasExcludedSeat && upsellHasIncludedSeat) utils.stages.lowest_with_exclusion_upsell_with_inclusion();
  if (lowestHasExcludedSeat && upsellHasSellableSeat) utils.stages.lowest_with_exclusion_upsell_with_sellable();
  if (lowestHasBasicSellableSeat) utils.stages.lowest_with_basic_sellable();
  if (lowestHasExcludedSeat) utils.stages.lowest_with_seats_excluded();
};

const isSeat = (feature: UIBrandedFareFeature) => feature.category === "SEATS";
const isIncludedSeat = (feature: UIBrandedFareFeature) => isSeat(feature) && feature.availability === "INCLUDED";
const isSellableSeat = (feature: UIBrandedFareFeature) => isSeat(feature) && feature.availability === "SELLABLE";
const isExcludedSeat = (feature: UIBrandedFareFeature) => isSeat(feature) && feature.availability === "NOT_INCLUDED";
const isBasicSellableSeat = (feature: UIBrandedFareFeature) =>
  isSellableSeat(feature) && feature.featureName === "BASIC_SEAT";

export default { ...utils, trackStages };
